import { match as integer } from "../../../src/params/integer.ts";
import { match as lang } from "../../../src/params/lang.js";

export const matchers = { integer, lang };